module.exports = __webpack_public_path__ + "assets/img/patient-add-banner.c141e98e.png";